import { render, staticRenderFns } from "./BattleWinners.vue?vue&type=template&id=8db8ad62&scoped=true"
import script from "./BattleWinners.vue?vue&type=script&lang=js"
export * from "./BattleWinners.vue?vue&type=script&lang=js"
import style0 from "./BattleWinners.vue?vue&type=style&index=0&id=8db8ad62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db8ad62",
  null
  
)

export default component.exports